export const initialize = (step, substep, percent, text) => {
    const ProgressBar = require('progressbar.js');

    let navigation = document.querySelectorAll('.list__item');
    let subnaviagtion = navigation[step].querySelectorAll('.sublist__item')[substep];

    let circle = new ProgressBar.Circle('.navigation__progress', {
        strokeWidth: 8,
        trailWidth: 8,
        color: '#ffffff',
        trailColor: '#313280',
        text: {
            value: text
        }
    });

    circle.path.setAttribute('stroke-linecap', 'round');
    circle.animate(percent);

    for (let i = 0; i < step; i++) {
        navigation[i].classList.add('list__item--checked');
    }

    navigation[step].classList.add('list__item--active');

    if (subnaviagtion) {
        subnaviagtion.classList.add('sublist__item--active');
    }
}